export const fields = {
    accessType: {
        type: 'AccessTypeEnum',
    },
    actions: {
        type: '[Action]',
    },
    allPageCount: {
        type: 'Number',
    },
    area: {
        type: 'String',
    },
    candidateGroupIds: {
        type: '[String]',
    },
    candidateId: {
        type: 'String',
    },
    candidateState: {
        type: 'String',
    },
    city: {
        type: 'String',
    },
    client: {
        type: 'Client',
    },
    clientId: {
        type: 'String',
    },
    clientState: {
        type: 'ClientStateEnum',
    },
    comment: {
        type: 'String',
    },
    contactClientId: {
        type: 'String',
    },
    contactClientList: {
        type: '[ContactClient]',
    },
    contacts: {
        type: '[Contact]',
    },
    containsWord: {
        type: 'Boolean',
    },
    coreSkills: {
        type: '[String]',
    },
    country: {
        type: 'String',
    },
    creator: {
        type: 'Person',
    },
    creatorId: {
        type: 'String',
    },
    currency: {
        type: 'CurrencyTypeEnum',
    },
    currentPosition: {
        type: 'String',
    },
    currentWorkPlace: {
        type: 'String',
    },
    customFields: {
        type: '[Field]',
    },
    date: {
        type: 'Unix timestamp',
    },
    dateFinish: {
        type: 'Unix timestamp',
    },
    dateFrom: {
        type: 'Unix timestamp',
    },
    dateTo: {
        type: 'Unix timestamp',
    },
    db: {
        type: 'Unix timestamp',
    },
    dc: {
        type: 'Unix timestamp',
    },
    descr: {
        type: 'String',
    },
    dm: {
        type: 'Number',
    },
    employmentType: {
        type: 'EmploymentTypeEnum',
    },
    expirence: {
        type: 'ExperienceEnum',
    },
    experience: {
        type: 'ExperienceEnum',
    },
    fieldId: {
        type: 'String',
    },
    fieldValues: {
        type: '[FieldValue]',
    },
    fileLinks: {
        type: '[FileLink]',
    },
    firstName: {
        type: 'String',
    },
    fromGoogle: {
        type: 'Boolean',
    },
    fullName: {
        type: 'String',
    },
    googlePlaceId: {
        type: 'String',
    },
    hideSalary: {
        type: 'Boolean',
    },
    industry: {
        type: 'String',
    },
    interviews: {
        type: '[Interview]',
    },
    interviewStatus: {
        type: 'InterviewStatusEnum',
    },
    languages: {
        type: '[Language]',
    },
    lastName: {
        type: 'String',
    },
    lat: {
        type: 'double',
    },
    limitReached: {
        type: 'Boolean',
    },
    lng: {
        type: 'double',
    },
    localId: {
        type: 'String',
    },
    number: {
        type: 'Number',
    },
    numberOfPositions: {
        type: 'String',
    },
    objectType: {
        type: 'ObjectEnum',
    },
    objId: {
        type: 'String',
    },
    objName: {
        type: 'ObjectEnum',
    },
    orgId: {
        type: 'String',
    },
    origin: {
        type: 'CandidateSourceEnum',
    },
    page: {
        type: 'Page',
    },
    person: {
        type: 'Person',
    },
    personId: {
        type: 'String',
    },
    phone: {
        type: 'String',
    },
    position: {
        type: 'String',
    },
    readyRelocate: {
        type: 'boolean',
    },
    recrutRole: {
        type: 'RoleEnum',
    },
    region: {
        type: 'Region',
    },
    regionId: {
        type: 'String',
    },
    relatedRegions: {
        type: '[Region]',
    },
    relocatedRegionIds: {
        type: '[String]',
    },
    responsible: {
        type: 'Person',
    },
    responsibleId: {
        type: 'String',
    },
    responsibles: {
        type: '[Person]',
    },
    responsiblesPerson: {
        type: '[Person]',
    },
    salary: {
        type: 'Number',
    },
    salaryFrom: {
        type: 'Number',
    },
    salaryTo: {
        type: 'Number',
    },
    sex: {
        type: 'boolean',
    },
    size: {
        type: 'Number',
    },
    skills: {
        type: '[Skill]',
    },
    sort: {
        type: 'SortEnum',
    },
    sortOrder: {
        type: 'SortOrderEnum',
    },
    state: {
        type: 'String',
    },
    status: {
        type: 'String',
    },
    testIds: {
        type: '[String]',
    },
    title: {
        type: 'String',
    },
    total: {
        type: 'Number',
    },
    type: {
        type: 'String',
    },
    userId: {
        type: 'String',
    },
    vacanciesForCandidatesAccess: {
        type: 'AccessTypeEnum',
    },
    vacancyId: {
        type: 'String',
    },
    words: {
        type: 'String',
    }
}